import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/auth';
import successSound from '../sounds/login.mp3';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const audioRef = useRef(new Audio(successSound));

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const {access_token, access_level} = await login(username, password);
      onLogin(access_token, access_level);
      navigate('/profile');
      // audioRef.current.play();
    } catch (err) {
      setError('Invalid credentials');
      console.error(err);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4 mx-auto">
          <h1>Вход в систему</h1>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className='text-center' style={{ marginBottom: '15px' }}>
              <label>Логин:</label>
              <input type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control"
                placeholder="username"
                required
              />
            </div>
            <div className='text-center' style={{ marginBottom: '15px' }}>
              <label>Пароль:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                required
              />
            </div>
            <button type="submit" className="btn w-100">
              Войти
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;